import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"src/sections/Top/Top.tsx\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"weight\":[\"400\",\"700\"],\"display\":\"swap\"}],\"variableName\":\"montserat\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Hand"] */ "/vercel/path0/src/components/Hand.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/sections/Galery/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MasonryGrid"] */ "/vercel/path0/src/sections/Masonry/MasonryGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/sections/Reviews.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LogoutButton"] */ "/vercel/path0/src/sections/Top/LogoutButton.tsx");
